import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_timer = _resolveComponent("timer");
  const _component_survey_quiz = _resolveComponent("survey-quiz");
  const _component_quiz_preamble = _resolveComponent("quiz-preamble");
  const _component_Slide = _resolveComponent("Slide");
  const _component_quiz_viewer_carousel = _resolveComponent("quiz-viewer-carousel");
  const _component_information_dialog = _resolveComponent("information-dialog");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_quiz_viewer_layout = _resolveComponent("quiz-viewer-layout");
  return _ctx.quiz ? (_openBlock(), _createBlock(_component_quiz_viewer_layout, {
    key: 0
  }, _createSlots({
    content: _withCtx(() => [_ctx.quizAnswered ? (_openBlock(), _createBlock(_component_survey_quiz, {
      key: 0,
      quiz: _ctx.quiz,
      "quiz-result": _ctx.realtimeUserAnswers,
      "is-result-mode": true,
      "can-edit": _ctx.canEdit,
      "is-speach-template": _ctx.isSpeachTemplate
    }, null, 8, ["quiz", "quiz-result", "can-edit", "is-speach-template"])) : (_openBlock(), _createBlock(_component_quiz_viewer_carousel, {
      key: 1,
      ref: "surveyQuizViewerCarousel",
      onSlideEnd: _ctx.onSlideChange
    }, {
      slides: _withCtx(() => [_createVNode(_component_Slide, {
        key: "0"
      }, {
        default: _withCtx(() => [_createVNode(_component_quiz_preamble, {
          icon: "chart-box-outline",
          title: _ctx.$t('view.speach.surveyQuiz.start.title'),
          items: _ctx.preambleItems,
          "can-edit": _ctx.canEdit,
          "is-speach-template": _ctx.isSpeachTemplate
        }, null, 8, ["title", "items", "can-edit", "is-speach-template"])]),
        _: 1
      }), _createVNode(_component_Slide, {
        key: "1"
      }, {
        default: _withCtx(() => [_ctx.activeStep === 1 ? (_openBlock(), _createBlock(_component_survey_quiz, {
          key: 0,
          quiz: _ctx.quiz,
          "can-edit": _ctx.canEdit,
          "is-speach-template": _ctx.isSpeachTemplate,
          onAnswerChange: _ctx.onQuizAnswerChange
        }, null, 8, ["quiz", "can-edit", "is-speach-template", "onAnswerChange"])) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["onSlideEnd"])), _createVNode(_component_information_dialog, {
      visible: _ctx.timeElapsed,
      width: "600px",
      title: _ctx.$t('view.speach.surveyQuiz.timeOverDialog.title'),
      message: _ctx.$t('view.speach.surveyQuiz.timeOverDialog.message')
    }, null, 8, ["visible", "title", "message"])]),
    _: 2
  }, [_ctx.timer && !_ctx.quizAnswered ? {
    name: "timer",
    fn: _withCtx(() => [_createVNode(_component_timer, {
      ref: "timerComponent",
      timer: _ctx.remainingSeconds,
      onCountdownEnd: _ctx.countdownEnd,
      class: "timer"
    }, null, 8, ["timer", "onCountdownEnd"])]),
    key: "0"
  } : undefined, !_ctx.quizAnswered ? {
    name: "footer",
    fn: _withCtx(() => [_createVNode(_component_standard_button, {
      label: _ctx.footerButtonLabel,
      onAction: _cache[0] || (_cache[0] = $event => _ctx.onNextStepButtonClick())
    }, null, 8, ["label"])]),
    key: "1"
  } : undefined]), 1024)) : _createCommentVNode("", true);
}